import React from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import qs from 'qs'
import { previewState } from '../../recoil/state/preview'
import { modalBuyCollaborationState } from '../../recoil/state/modals'

import {
  editMessageCallback,
  openCollaborationCallback
} from '../../recoil/callbacks/callbacks'

import { notifyOpener } from 'Helpers/notifyParent'

import Head from '../Head'

const HeadComponent = () => {
  const intl = useIntl()
  const { source } = qs.parse(useLocation().search)

  const {
    id,
    title,
    notes,
    actions,
    recipient,
    tooltip,
    idList
  } = useRecoilValue(previewState)
  const setShowPersonalization = useSetRecoilState(previewState)

  const editMessage = useRecoilCallback(editMessageCallback, [])
  const openCollaboration = useRecoilCallback(openCollaborationCallback, [])
  const setModalBuyCollaboration = useSetRecoilState(modalBuyCollaborationState)

  const overviewRoute = `/messages/email/${id}/overview?source=EmailMessages&op=mod`
  const overviewUrl = `messages_app_redirector.aspx?r=${encodeURIComponent(
    overviewRoute
  )}`

  const allActions = {
    overview: {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Overview' }),
      onClick: () => {
        notifyOpener('setCurrentList', [idList, overviewUrl, true])

        window.opener && window.close()
      },
      'data-mu-test': 'action__overview'
    },
    edit: {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
      onClick: () => editMessage(source),
      'data-mu-test': 'action__edit'
    },
    checkup: {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Checkup' }),
      onClick: () => {
        const route = `/messages/email/${id}/checkup/summary`

        notifyOpener('setCurrentList', [
          idList,
          `messages_app_redirector.aspx?r=${encodeURIComponent(route)}`,
          true
        ])

        window.opener && window.close()
      },
      'data-mu-test': 'action__checkup'
    },
    quickSend: {
      label: intl.formatMessage({
        id: 'Load.EmailCheckUp.QuickSendMenuTitle'
      }),
      onClick: () => {
        notifyOpener('quickSendMessage', [id])

        window.opener && window.close()
      },
      'data-mu-test': 'action__quick-send'
    },
    collaboration: {
      label: intl.formatMessage({
        id: 'Load.Collaboration.Collaborate'
      }),
      onClick: openCollaboration,
      'data-mu-test': 'action__collaboration'
    },
    collaborationUpselling: {
      label: intl.formatMessage({
        id: 'Load.Collaboration.Collaborate'
      }),
      onClick: () => setModalBuyCollaboration({ show: true }),
      'data-mu-test': 'action__collaboration-upselling'
    },
    statistics: {
      label: intl.formatMessage({
        id: 'Load.MailupCommon.ActionStatistics'
      }),
      onClick: () => {
        notifyOpener('setCurrentList', [
          idList,
          `statistics_app_redirector.aspx?r=/stats/sendouts/sending/mode/messages/0/${id}`,
          true
        ])

        window.opener && window.close()
      },
      'data-mu-test': 'action__statistics'
    }
  }

  const actionItems = Object.keys(allActions).reduce(
    (accumulator, action) =>
      actions[action] ? [...accumulator, allActions[action]] : accumulator,
    []
  )

  const showRecipientForm = () => {
    setShowPersonalization(prev => ({
      ...prev,
      showPersonalization: true
    }))
  }

  const makeTooltip = () => {
    let translate

    if (tooltip) {
      if (tooltip.type === 'group') {
        translate = intl.formatMessage(
          {
            id: 'Load.PreviewViewer.emailReferenceRecipientTooltipGroups'
          },
          {
            NAME: tooltip.value,
            strong: content => (
              <strong key={content} style={{ whiteSpace: 'nowrap' }}>
                {content}
              </strong>
            )
          }
        )
      }
      if (tooltip.type === 'filter') {
        translate = intl.formatMessage(
          {
            id: 'Load.PreviewViewer.emailReferenceRecipientTooltipFilters'
          },
          {
            NAME: tooltip.value,
            strong: content => (
              <strong key={content} style={{ whiteSpace: 'nowrap' }}>
                {content}
              </strong>
            )
          }
        )
      }
    }

    return translate
  }

  return (
    <Head
      id={id}
      title={title}
      notes={notes}
      email={recipient}
      actionItems={actionItems}
      tooltip={makeTooltip()}
      showCallback={showRecipientForm}
    />
  )
}

export default HeadComponent
